<template>
  <div
    class="question-stem-component-container"
    data-test="question-stem"
  >
    <topic
      v-if="embeddedTopic"
      :topic="embeddedTopic"
      :send-analytics="true"
      :show-title="false"
      :source="topicSource"
    />
    <div
      class="flashcard-content"
      :class="{ 'plain-text': flashcard.userOwned }"
      v-html="flashcardQuestion"
    ></div>
    <old-asset-associations-list
      v-if="assetAssociationButtons.length > 0"
      :asset="flashcard"
      context="question"
      @flashcard-aa-clicked="$emit('flashcard-aa-clicked', $event)"
    />
  </div>
</template>

<script>
import OldAssetAssociationsList from '@components/flashcards-v2/fragments/OldAssetAssociationsList';
import Topic from '@components/topics/topic';

export default {
  components: { OldAssetAssociationsList, Topic },
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    category: {
      type: Object,
      default: null,
    },
  },
  emits: ['flashcard-aa-clicked'],
  computed: {
    assetAssociationButtons() {
      return (this.flashcard.assetAssociations || []).filter(aa => aa.displayType !== 'embed_before');
    },
    embeddedTopic() {
      if (this.flashcard.assetAssociations) {
        const topicAA = this.flashcard.assetAssociations.find(aa => aa.assetBType === 'Topic' && aa.displayType === 'embed_before');
        if (topicAA) {
          return this.$store.getters['topics/topics'][topicAA.assetBId];
        }
      }
    },
    flashcardQuestion() {
      let text = '';
      const flashcardTypes = ['Highlight', 'Cloze / Dropdown'];
      if( !flashcardTypes.includes(this.flashcard.type) ) {
        text = this.flashcard.question;
      }
      return text;
    },
    topicSource() {
      return {
        sourceId: this.flashcard?.id,
        sourceType: 'Flashcard',
        sourceCategoryId: this.category?.id,
        sourceCategory: this.category?.name,
      };
    },

  },
};
</script>

<style lang="scss" scoped>
.flashcard-content {
  line-height: rem-calc(24);
  max-width: 60ch;
  // first-child no top-margin deep selector p
  :deep(:first-child) {
    margin-top: 0;
  }

  // last-child no bottom-margin deep selector p
  :deep(:last-child) {
    margin-bottom: 0;
  }
  margin-bottom: 1.5rem;

  // Generated questions are plain text, so keep their line breaks (e.g. "Select all that apply." on its own line)
  &.plain-text {
    white-space: pre-line;
  }
}
</style>
